import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Button from './Button';

interface ConfirmationDialogProps {
  open: boolean;
  content: string;
  onClose: () => void;
  onCancel: () => void;
  onAccept: () => void;
}

const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  submitButton: {
    marginLeft: spacing(1),
    display: 'flex',
    flexDirection: 'column',
  },

  closeText: {
    color: palette.neutral[100],
    fontSize: '0.875rem',
    textTransform: 'uppercase',
  },
}));

const ConfirmationDialog = ({ open, content, onClose, onCancel, onAccept }: ConfirmationDialogProps): JSX.Element => {
  const styles = useStyles();
  return (
    <>
      <Dialog onClose={onClose} open={open} title="Confirmação de alteração">
        <DialogTitle>Confirmação</DialogTitle>
        <DialogContent>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={onCancel}>
            <span className={styles.closeText}>Fechar</span>
          </Button>
          <div className={styles.submitButton}>
            <Button onClick={onAccept}>Continuar</Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default ConfirmationDialog;
